<div class="confirm-register-card" *ngIf="!validationEmail">
    <div class="confirm-register-header">
        <div class="confirm-register-icon">
            <img src="./assets/images/circle-check-register.svg" alt="icon register success" *ngIf="!showPageValidateEmail">
            <img src="./assets/images/timer.svg" alt="icon timer success" *ngIf="showPageValidateEmail">
        </div>
        <h2 class="confirm-register-title{{ showPageValidateEmail ? '-check' : '' }}">
            {{ showPageValidateEmail ? 'Ya te enviamos un mail': '¡Listo! Ya te registraste'}}
        </h2>
        <p class="confirm-register-subtitle">Te enviamos un link a tu e-mail</p>
        <p class="confirm-register-email">{{ userEmail | maskEmail }} para validar tu cuenta</p>
        <p class="confirm-register-info{{ showPageValidateEmail ? '-check' : '' }}">
            Recordá revisar el correo no deseado y promociones.
        </p>
    </div>

    <div class="confirm-register-buttons" *ngIf="!showPageValidateEmail else timerDesing">
        <p class="confirm-register-help">
            Si tenes alguna duda por favor escribinos a <b>shellbox&#64;raizen.com.ar</b>
        </p>
        <button class="confirm-register-btn" type="button" (click)="closeConfirmRegister()">
            Entendido
        </button>
        <button class="confirm-register-resend" type="button" (click)="resendEmailEvent()">
            Reenviar e-mail
        </button>
    </div>

    <ng-template #timerDesing>
        <div class="resend-email-container{{ !showTimer ? '-finished' : '' }}">
            <span *ngIf="showTimer">
                <b>{{ formattedTime }}</b>
                <span> Enviarme un nuevo e-mail</span>
            </span>
            <button *ngIf="!showTimer" [disabled]="isLoading" (click)="resendEmailEvent()">
                Enviarme un nuevo e-mail
            </button>
        </div>
    </ng-template>
</div>
